/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: { color: '#666666', maxHeight: '100%', overflowY: 'visible' }
}
export default theme
